import { addMonths, format as formatDate, startOfWeek, subWeeks } from 'date-fns';
import { getScheduleViewDateRange } from './schedulePlannedDateWindow';

/**
 * Date window for schedule table API calls. When either schedule filter date is set, uses that
 * inclusive window; otherwise matches the default "weeks" Gantt range (four weeks before current
 * week start through four months after).
 */
export function getScheduleTableDateRange(startDate: string, endDate: string): { dateFrom: string; dateTo: string } {
  const planned = getScheduleViewDateRange(startDate, endDate);
  if (planned) {
    return {
      dateFrom: formatDate(planned.from, 'yyyy-MM-dd'),
      dateTo: formatDate(planned.to, 'yyyy-MM-dd'),
    };
  }
  const now = new Date();
  const weekStart = startOfWeek(now, { weekStartsOn: 1 });
  const from = subWeeks(weekStart, 4);
  const to = addMonths(weekStart, 4);
  return {
    dateFrom: formatDate(from, 'yyyy-MM-dd'),
    dateTo: formatDate(to, 'yyyy-MM-dd'),
  };
}
